import React from 'react';

import { Flex } from 'antd';
import { useGlobal } from 'src/contexts/GlobalContext';

import {
  CardWrapper,
  ChildrenWrapper,
  ContentWrapper,
  HeaderWrapper,
  RenderCardWrapper,
  SectionDescription,
  StyledDivider,
  Title,
  TitleWrapper,
  Wrapper,
} from './SettingCard.styled';

interface ItemProps {
  header?: React.ReactNode;
  content?: React.ReactNode;
  action?: React.ReactNode;
  isContentHidden?: boolean;
}

export interface SettingCardProps {
  items: ItemProps[];
  title: string;
  description?: string;
  isDisabled?: boolean;
  withoutCard?: boolean;
  withoutPadding?: boolean;
  verticallyCentered?: boolean;
  horizontallyCentered?: boolean;
  horizontalChildren?: boolean;
  contentStyles?: React.CSSProperties;
  isCard?: boolean;
}

export const SettingCard = (props: SettingCardProps) => {
  const {
    items,
    title,
    description,
    isDisabled,
    withoutCard = false,
    withoutPadding = false,
    verticallyCentered = false,
    horizontallyCentered = false,
    horizontalChildren = false,
    contentStyles,
    isCard = false,
  } = props;
  const { isDesktop } = useGlobal();

  const renderContent = (item: ItemProps) => {
    return (
      <>
        {item?.header && (
          <>
            <HeaderWrapper>{item.header}</HeaderWrapper>
            <StyledDivider />
          </>
        )}
        {item?.content && !item.isContentHidden && (
          <ContentWrapper
            className="setting-card-content-wrapper"
            $withoutCard={withoutCard}
            $isDesktop={isDesktop}
            $withoutPadding={withoutPadding}
            style={{ ...contentStyles }}
          >
            {item.content}
          </ContentWrapper>
        )}
      </>
    );
  };

  const renderCard = (item: ItemProps) => (
    <RenderCardWrapper>
      {item?.action && <Flex>{item.action}</Flex>}
      {withoutCard ? renderContent(item) : <CardWrapper>{renderContent(item)}</CardWrapper>}
    </RenderCardWrapper>
  );

  const renderChildren = items?.map((element, index) => (
    <React.Fragment key={index}>{renderCard(element)}</React.Fragment>
  ));

  return (
    <Wrapper $isDesktop={isDesktop} $isDisabled={isDisabled} $isCard={isCard}>
      <TitleWrapper $isDesktop={isDesktop}>
        <Title $isDisabled={isDisabled}>{title}</Title>
        {description ? <SectionDescription $isDisabled={isDisabled}>{description}</SectionDescription> : null}
      </TitleWrapper>
      <ChildrenWrapper
        $verticallyCentered={verticallyCentered}
        $horizontallyCentered={horizontallyCentered}
        $horizontal={horizontalChildren}
      >
        {renderChildren}
      </ChildrenWrapper>
    </Wrapper>
  );
};
